import { render, staticRenderFns } from "./InviteDetail.vue?vue&type=template&id=d15f84b8&scoped=true&"
import script from "./InviteDetail.vue?vue&type=script&lang=js&"
export * from "./InviteDetail.vue?vue&type=script&lang=js&"
import style0 from "./InviteDetail.vue?vue&type=style&index=0&id=d15f84b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d15f84b8",
  null
  
)

export default component.exports